export const AUTHOR_QUERY_PARAM = "autor"
